<template>
  <el-dialog
    v-model="visible"
    width="800px"
    transition="dialog-bounce"
    :show-close="false"
    align-center
    lock-scroll
    :close-on-click-modal="false"
  >
    <template #header="{ close }">
      <div class="dialog-header">
        <el-icon :size="20" @click="close" class="close-btn">
          <Close />
        </el-icon>
        <h2>查看物流</h2>
      </div>
    </template>
    <div v-if="trackData" class="dialog-content">
      <div class="wuliu_box flex-column animated linearTop">
        <div class="wuliu_company flex-column">
          <div class="company_name" v-if="trackData.expressName">
            <div class="c_name_left">物流公司:</div>
            <div class="c_name_right">{{ trackData.expressName }}</div>
          </div>
          <div class="company_name">
            <div class="c_name_left">物流单号:</div>
            <div class="c_name_right flex">
              {{ trackData.expressNumber }}
              <el-button type="primary" link @click="copyNumber">复制 </el-button>
            </div>
          </div>
          <div class="company_name">
            <div class="c_name_left">当前状态:</div>
            <div class="c_name_right">{{ trackData.statusDesc }}</div>
          </div>
        </div>
        <div class="wuliu_list" v-if="trackData.tracks">
          <el-steps style="max-height: 300px; max-width: 600px" align-center>
            <el-step
              v-for="item in trackData.tracks"
              :key="item.status"
              :title="item.status + ' ' + item.time"
              :description="item.content"
            />
          </el-steps>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
  import { ref, defineExpose, unref } from 'vue'
  import { ElMessage } from 'element-plus'
  import { getExpressTrack } from '@/api/user'
  import { copyText } from '@/utils'

  const visible = ref(false)

  const trackData = ref()

  const show = async id => {
    try {
      const result = await getExpressTrack(id)
      if (!result) return ElMessage.error('获取物流信息失败')
      visible.value = true
      trackData.value = result
    } catch (error) {
      ElMessage.error(error)
    }
  }

  const copyNumber = () => {
    copyText(unref(trackData).expressNumber)
      .then(() => {
        ElMessage.success('复制成功')
      })
      .catch(() => {
        ElMessage.error('复制失败')
      })
  }

  defineExpose({ show })
</script>

<style lang="scss" scoped>
  .dialog-header {
    position: relative;

    h2 {
      font-size: 20px;
      font-weight: 700;
      text-align: center;
    }

    .close-btn {
      position: absolute;
      right: 0;
      cursor: pointer;
    }
  }

  .dialog-content {
    .wuliu_box {
      background: #fff;
      border-radius: 6px;
      position: relative;
      padding: 10px;
    }

    .wuliu_header {
      width: 100%;
      height: 42px;
      color: #111;
      font-size: 16px;
      display: flex;
    }

    .wuliu_company {
      width: 100%;
      height: auto;
    }

    .company_name {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
    }

    .c_name_left {
      margin-right: 2px;
    }

    .c_name_right.flex {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    .chaxun_close {
      width: 100%;
      height: 40px;
      border-top: 1px solid #f1f1f1;
      position: absolute;
      bottom: 0;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .close_btn {
      width: 60px;
      height: auto;
    }

    .wuliu_list {
      margin-top: 15px;
    }
  }

  :deep(.el-steps) {
    .el-step__title {
      font-size: 14px;
    }
  }
</style>
